import { CardCtrlApp } from "@/client/components/card-ctrl/card-ctrl-app";

function App() {
  return <CardCtrlApp />;
}

export default App;
